import { css as r } from "styled-components";
const t = (o) => o.componentColors.errorSummary, e = {
  wrapper: ({ theme: o, role: s }) => s === "alert" ? /* @__PURE__ */ r([
    "border:0.2rem solid ",
    ";border-radius:0.4rem;padding:",
    ";margin-bottom:",
    ";&:focus{",
    "}"
  ], t(o).border, o.space.sm, o.space.md, o.components.forms.borderStyle) : /* @__PURE__ */ r([
    "",
    ""
  ], o.components.visuallyHidden),
  button: ({ theme: o }) => /* @__PURE__ */ r([
    "display:block;color:",
    ";text-align:left;&:hover{color:",
    ";}"
  ], t(o).button, t(o).buttonHover),
  alertIcon: ({ theme: o }) => /* @__PURE__ */ r([
    "margin-right:",
    ";width:calc(1em - 2px);height:calc(1em - 2px);position:relative;top:1px;"
  ], o.space.xs),
  list: ({ theme: o }) => /* @__PURE__ */ r([
    "",
    " ",
    " li{margin-bottom:",
    ";&:last-child{margin-bottom:0;}}"
  ], o.resets.space, o.resets.list.item, o.space.xs)
};
export {
  e as default
};
